@if (!isLoading) {
    <div class="ml-5">
        <form [formGroup]="settingsForm" (ngSubmit)="onSubmit()">
            <h2 class="section-title">{{ 'components.settingsForm.userSection.title' | translate }}</h2>
            <div class="card">
                <div class="form-grid form-grid--2" formGroupName="userGroup">
                    <div class="form-field">
                        <label for="lastnameInput" class="form-field__label form-field__label--required">
                            {{ 'components.settingsForm.userSection.lastname.label' | translate }}
                        </label>
                        <input
                            id="lastnameInput"
                            pInputText
                            type="text"
                            formControlName="lastname"
                            [placeholder]="'components.settingsForm.userSection.lastname.placeholder' | translate" />
                        @if (
                            userFormGroup.controls.lastname.invalid &&
                            userFormGroup.controls.lastname.errors?.required &&
                            userFormGroup.controls.lastname.touched
                        ) {
                            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                        }
                    </div>
                    <div class="form-field">
                        <label for="firstnameInput" class="form-field__label form-field__label--required">
                            {{ 'components.settingsForm.userSection.firstname.label' | translate }}
                        </label>
                        <input
                            id="firstnameInput"
                            pInputText
                            type="text"
                            formControlName="firstname"
                            [placeholder]="'components.settingsForm.userSection.firstname.placeholder' | translate" />
                        @if (
                            userFormGroup.controls.firstname.invalid &&
                            userFormGroup.controls.firstname.errors?.required &&
                            userFormGroup.controls.firstname.touched
                        ) {
                            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                        }
                    </div>
                    <div class="form-field">
                        <label for="roleInput" class="form-field__label">
                            {{ 'components.settingsForm.userSection.role.label' | translate }}
                        </label>
                        <input
                            id="roleInput"
                            pInputText
                            type="text"
                            formControlName="role"
                            [placeholder]="'components.settingsForm.userSection.role.placeholder' | translate" />
                    </div>
                    <div class="form-field">
                        <label for="emailInput" class="form-field__label form-field__label--required">
                            {{ 'components.settingsForm.userSection.email.label' | translate }}
                        </label>
                        <input
                            id="emailInput"
                            pInputText
                            type="text"
                            formControlName="email"
                            [placeholder]="'components.settingsForm.userSection.email.placeholder' | translate" />
                        @if (
                            userFormGroup.controls.email.invalid &&
                            userFormGroup.controls.email.errors?.required &&
                            userFormGroup.controls.email.touched
                        ) {
                            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                        }
                        @if (
                            userFormGroup.controls.email.invalid &&
                            userFormGroup.controls.email.errors?.invalidEmail &&
                            userFormGroup.controls.email.touched
                        ) {
                            <small class="p-error">{{
                                'components.settingsForm.userSection.email.validation.invalid' | translate
                            }}</small>
                        }
                    </div>
                    <div class="form-field">
                        <label for="phoneNumberInput" class="form-field__label form-field__label--required">
                            {{ 'components.settingsForm.userSection.phoneNumber.label' | translate }}
                        </label>
                        <input
                            id="phoneNumberInput"
                            pInputText
                            type="text"
                            formControlName="phoneNumber"
                            [placeholder]="'components.settingsForm.userSection.phoneNumber.placeholder' | translate" />
                        @if (
                            userFormGroup.controls.phoneNumber.invalid &&
                            userFormGroup.controls.phoneNumber.errors?.required &&
                            userFormGroup.controls.phoneNumber.touched
                        ) {
                            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                        }
                        @if (
                            userFormGroup.controls.phoneNumber.invalid &&
                            userFormGroup.controls.phoneNumber.errors?.invalidPn &&
                            userFormGroup.controls.phoneNumber.touched
                        ) {
                            <small class="p-error">{{
                                'components.settingsForm.userSection.phoneNumber.validation.invalid' | translate
                            }}</small>
                        }
                    </div>
                    <div class="form-field">
                        <label for="defaultLocaleInput" class="form-field__label">
                            {{ 'components.settingsForm.userSection.defaultLocale.label' | translate }}
                        </label>
                        <p-select
                            inputId="defaultLocaleInput"
                            [options]="availableLanguages"
                            formControlName="defaultLocale"
                            appendTo="body">
                            <!-- Language codes read in capitals (FR, NL…). -->
                            <ng-template pTemplate="selectedItem" let-selected>{{ selected | uppercase }}</ng-template>
                            <ng-template let-locale pTemplate="item">{{ locale | uppercase }}</ng-template>
                        </p-select>
                    </div>
                    @if (isPlatformAdmin) {
                        <div class="form-field">
                            <label for="clientInput" class="form-field__label form-field__label--required">
                                {{ 'components.settingsForm.userSection.client.label' | translate }}
                            </label>
                            <p-select
                                inputId="clientInput"
                                [options]="clientOptions"
                                formControlName="client"
                                optionLabel="name"
                                optionValue="id"
                                [showClear]="true"
                                [placeholder]="'components.settingsForm.userSection.client.placeholder' | translate"
                                appendTo="body">
                            </p-select>
                            @if (
                                userFormGroup.controls.client.invalid &&
                                userFormGroup.controls.client.errors?.required &&
                                userFormGroup.controls.client.touched
                            ) {
                                <small class="p-error">{{
                                    'common.forms.validationMessages.required' | translate
                                }}</small>
                            }
                        </div>
                    }
                </div>
            </div>
            <div class="form-actions">
                <!-- Deleting a dedicated admin is switched off for now. -->
                @if (false) {
                    <p-button
                        class="form-actions__start"
                        severity="danger"
                        [text]="true"
                        icon="ms ms-delete"
                        [label]="'components.settingsForm.button.remove' | translate"
                        (onClick)="delete()" />
                }
                @if (createMode) {
                    <p-button type="submit" [label]="'components.settingsForm.button.create' | translate" />
                }
            </div>
        </form>
        <p-confirmDialog />
    </div>
} @else {
    <div class="w-full">
        <div class="w-full">
            <p-skeleton width="20rem" height="2rem"></p-skeleton>
            <!-- CARD -->
            <div class="card flex flex-column mt-3 gap-4">
                <!-- ROW -->
                <div class="flex w-full gap-3">
                    <!-- INPUT -->
                    <div class="flex flex-column w-full gap-2">
                        <p-skeleton width="10rem" height="1rem"></p-skeleton>
                        <p-skeleton width="100%" height="2rem"></p-skeleton>
                    </div>
                    <!-- INPUT -->
                    <div class="flex flex-column w-full gap-2">
                        <p-skeleton width="10rem" height="1rem"></p-skeleton>
                        <p-skeleton width="100%" height="2rem"></p-skeleton>
                    </div>
                </div>
                <!-- ROW -->
                <div class="flex w-full gap-3">
                    <!-- INPUT -->
                    <div class="flex flex-column w-full gap-2">
                        <p-skeleton width="10rem" height="1rem"></p-skeleton>
                        <p-skeleton width="100%" height="2rem"></p-skeleton>
                    </div>
                    <!-- INPUT -->
                    <div class="flex flex-column w-full gap-2">
                        <p-skeleton width="10rem" height="1rem"></p-skeleton>
                        <p-skeleton width="100%" height="2rem"></p-skeleton>
                    </div>
                </div>
                <!-- ROW -->
                <div class="flex w-full gap-3">
                    <!-- INPUT -->
                    <div class="flex flex-column w-full gap-2">
                        <p-skeleton width="10rem" height="1rem"></p-skeleton>
                        <p-skeleton width="100%" height="2rem"></p-skeleton>
                    </div>
                    <!-- INPUT -->
                    <div class="flex flex-column w-full gap-2">
                        <p-skeleton width="10rem" height="1rem"></p-skeleton>
                        <p-skeleton width="100%" height="2rem"></p-skeleton>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
